import React, { useState, useEffect, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import './Videos.css';

const Videos = () => {
  const { t } = useLanguage();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const intervalRef = useRef(null);

  // Get videos from translations
  const videos = t.videos.items;

  // Auto-slide functionality
  useEffect(() => {
    if (!isPaused) {
      intervalRef.current = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % videos.length);
      }, 3000); // Change slide every 3 seconds
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isPaused, videos.length]);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % videos.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + videos.length) % videos.length);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const handleMouseEnter = () => {
    setIsPaused(true);
  };

  const handleMouseLeave = () => {
    setIsPaused(false);
  };

  return (
    <>
      <div style={{ clear: 'both' }} />
      <div className="videos-section" id="section-9">
        <div className="videos-wrap row">
          <div className="videos-title">
            <h4>
              <span style={{ color: '#ffbd2f' }}>{t.videos.name}</span>
            </h4>
            <p>{t.videos.subtitle}</p>
          </div>
          <div style={{ clear: 'both' }} />

          <div
            className="videos-slider"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <button className="vid-slider-arrow prev" onClick={prevSlide}>
              <i className="fa fa-chevron-left" />
            </button>

            <div className="videos-slider-container">
              {videos.map((video, index) => (
                <div
                  key={index}
                  className={`video-slide ${index === currentIndex ? 'active' : ''}`}
                  style={{ display: index === currentIndex ? 'block' : 'none' }}
                >
                  <div className="video-wrapper">
                    <iframe
                      src={`https://www.youtube.com/embed/${video.id}`}
                      title={video.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div>
                  <h5 className="video-title">{video.title}</h5>
                </div>
              ))}
            </div>

            <button className="vid-slider-arrow next" onClick={nextSlide}>
              <i className="fa fa-chevron-right" />
            </button>
          </div>

          <div className="videos-dots">
            {videos.map((_, index) => (
              <button
                key={index}
                className={`vid-dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Videos;
